export { PermissionService } from './permission.service';
export { PermissionModule } from './permission.module';



// WEBPACK FOOTER //
// /dist/src/app/security/permission/index.ts